import { Link } from '@tanstack/react-router';
import { Card, CardContent, CardHeader, CardTitle, Separator } from '@fade/ui';

import { useFeed } from '../lib/queries/feed';

export function FeedPage() {
  const { data, isPending, error } = useFeed(1);

  if (isPending) {
    return (
      <main className="mx-auto max-w-2xl px-6 py-16">
        <p className="text-muted-foreground">Loading the feed…</p>
      </main>
    );
  }

  if (error) {
    return (
      <main className="mx-auto max-w-2xl px-6 py-16">
        <p className="text-destructive">Failed to load: {String(error)}</p>
      </main>
    );
  }

  if (!data || data.items.length === 0) {
    return (
      <main className="mx-auto max-w-2xl px-6 py-16">
        <h1 className="font-serif text-3xl font-light">The feed is quiet</h1>
        <p className="mt-3 text-muted-foreground">No published stories yet.</p>
      </main>
    );
  }

  return (
    <main className="mx-auto max-w-2xl px-6 py-16">
      <header className="mb-8">
        <h1 className="font-serif text-3xl font-light">Stories</h1>
        <p className="mt-2 text-sm text-muted-foreground">{data.total} published</p>
      </header>

      <div className="space-y-6">
        {data.items.map((item, idx) => (
          <div key={item.id}>
            {idx > 0 ? <Separator className="mb-6" /> : null}
            <Card>
              <CardHeader>
                <CardTitle>
                  <Link
                    to="/legacies/$id"
                    params={{ id: item.id }}
                    className="hover:underline"
                  >
                    {item.title}
                  </Link>
                </CardTitle>
              </CardHeader>
              <CardContent className="space-y-2">
                {item.excerpt ? (
                  <p className="text-muted-foreground">{item.excerpt}</p>
                ) : (
                  <p className="line-clamp-3 text-sm text-foreground/80">
                    {item.body.slice(0, 240)}
                    {item.body.length > 240 ? '…' : ''}
                  </p>
                )}
                <div className="flex items-center justify-between text-xs text-muted-foreground">
                  <span>
                    {item.publishedAt
                      ? new Date(item.publishedAt).toLocaleDateString()
                      : ''}
                  </span>
                  <span>❤️ {item.rememberCount}</span>
                </div>
              </CardContent>
            </Card>
          </div>
        ))}
      </div>
    </main>
  );
}